export const getUserProperties = () => {
    const roles = window.config.state.roles;
    const cityClassTag = document.querySelector('.city')
        ? '.city'
        : '.select-geo-btn';
    const city = document.querySelector(cityClassTag)
        ? document.querySelector(cityClassTag).textContent
        : '';

    let rolesOutput = [];
    for (let role in roles) {
        rolesOutput.push(roles[role]);
    }

    const userProperties = {
        //** @doc обязательно необходимо присылать значение иначе присылается предыдущее */
        b2bArea: window.config.user.b2bArea || 'none',
        b2bRootArea: window.config.user.b2bRootArea || 'none',
        userId: window.config.user.id,
        isAuth: !window.config.user.isGuest,
        orderCount: !window.config.user.isGuest
            ? window.config.user.orderCount
            : '',
        split: window.config.state.split,
        theme: window.config.state.theme,
        url: window.location.href,
        city,
    };

    if (rolesOutput.length > 0) {
        userProperties.roles = rolesOutput;
    }

    return userProperties;
};
